import React from 'react'
import { useQuery } from '@apollo/client'
import styled from 'styled-components'

import users from '../../queries/v2/users'
import LoaderSpinner from '../../layout/loader'
import User from './User'
import { backgroundGray, navy } from '../../layout/colors'

const Main = () => {
  const { data, loading } = useQuery(users)

  if (loading) return <LoaderSpinner />
  return (
    <>
      <Container100vh>
        <Container>
          <Inner>
            <h1>Uživatelé</h1>
            <TableContainer>
              <Table>
                <TableHead>
                  <Th>ID</Th>
                  <Th>Oprávnění</Th>
                  <Th>Uživatelské jméno</Th>
                  <Th>Email</Th>
                  <Th>Jídelna</Th>
                  <Th></Th>
                  <Th></Th>
                </TableHead>
                {data?.users.map((item) => {
                  return <User item={item} />
                })}
              </Table>
            </TableContainer>
          </Inner>
        </Container>
      </Container100vh>
    </>
  )
}

export default Main

const Container100vh = styled.div`
  min-height: calc(100vh - 208.88px);

  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;

  background: url('/img/pattern_modry.svg'), ${navy};
  background-attachment: fixed;
  background-position: center;
  background-size: 730px;

  @media (min-width: 366px) {
    min-height: calc(100vh - 219.88px);
  }
`

const Container = styled.div`
  flex: 1;
  height: 100%;
`

const Table = styled.table`
  text-align: left;
  background-color: white;
  border-collapse: collapse;
  width: 100%;
`

const Inner = styled.div`
  text-align: center;
  background-color: white;
  box-shadow: 0rem 0.5rem 2rem rgb(0 0 0 / 20%);
  width: 80%;
  margin: 10px auto;
  border-radius: 5px;
  padding: 20px 20px;
`

const TableContainer = styled.div`
  overflow-x: scroll;

  @media (max-width: 566px) {
    margin: 0 14.5em;
  }

  @media (max-width: 400px) {
    margin: 0 450px;
  }
`

const TableHead = styled.tr`
  background-color: ${backgroundGray};
`
const Th = styled.th`
  padding: 10px;
  color: white;
  background-color: ${navy};
`
